import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import { useT } from "../hooks/useLang";

const C = {
  red:    "#E0392B",
  gold:   "#F2A720",
  green:  "#1E6E4B",
  blue:   "#2C5F88",
  cream:  "#F5EAD3",
  cream2: "#EADFC2",
  paper:  "#FBF3E2",
  ink:    "#211B16",
  inkSoft:"#473D34",
  purple: "#6E4F9E",
};

const STYLES = `
  @keyframes pulse-glow {
    0%, 100% { box-shadow: 0 0 0 0 rgba(224,57,43,0.3); }
    50%       { box-shadow: 0 0 0 12px rgba(224,57,43,0); }
  }
  @keyframes float {
    0%, 100% { transform: translateY(0px); }
    50%       { transform: translateY(-10px); }
  }
  @keyframes wb-fade-up {
    from { opacity: 0; transform: translateY(14px); }
    to   { opacity: 1; transform: none; }
  }
  .teasing-float { animation: float 4s ease-in-out infinite; }
  .wb-fade-up { animation: wb-fade-up .55s ease both; }
`;

const BAND_SVG = encodeURIComponent(
  `<svg xmlns='http://www.w3.org/2000/svg' width='96' height='44'>` +
  `<rect width='96' height='44' fill='#211b16'/>` +
  `<rect width='96' height='6' fill='#f2a720'/>` +
  `<path d='M0 32 L16 13 L32 32 L48 13 L64 32 L80 13 L96 32' fill='none' stroke='#e0392b' stroke-width='5'/>` +
  `<circle cx='16' cy='38' r='3' fill='#1e6e4b'/>` +
  `<circle cx='48' cy='38' r='3' fill='#2c5f88'/>` +
  `<circle cx='80' cy='38' r='3' fill='#f5ead3'/>` +
  `</svg>`
);
function Band() {
  return (
    <div style={{
      height: 44, width: "100%",
      background: `#211b16 url("data:image/svg+xml,${BAND_SVG}") repeat-x`,
      backgroundSize: "auto 100%",
    }} />
  );
}

export default function NosServices() {
  const t = useT();

  const SERVICES = [
    {
      emoji: "",
      name: "Wash Bros",
      tagline: t("washBrosTagline"),
      desc: t("washBrosDesc"),
      color: C.blue,
      bg: "#dbeafe",
    },
    {
      emoji: "",
      name: "Zamenoulli",
      tagline: t("zamenoulliTagline"),
      desc: t("zamenoulliDesc"),
      color: "#78350f",
      bg: "#fdf6ec",
    },
    {
      emoji: "",
      name: "WhoWe",
      tagline: t("whoWeTagline"),
      desc: t("whoWeDesc"),
      color: C.green,
      bg: "#dcfce7",
    },
  ];

  useEffect(() => {
    if (document.getElementById("teasing-styles")) return;
    const tag = document.createElement("style");
    tag.id = "teasing-styles";
    tag.textContent = STYLES;
    document.head.appendChild(tag);
  }, []);

  return (
    
    <div style={{ background: C.paper, overflowX: "hidden" }}>
      <Helmet>
        <title>Starting Five - Accueil</title>
        <meta name="description" content="Starting Five, groupe togolais proposant des services innovants pour simplifier votre quotidien." />
      </Helmet>

      {/* HERO */}
      <div style={{
        background: C.cream2,
        borderBottom: `4px solid ${C.ink}`,
        padding: "64px 20px 72px",
        textAlign: "center",
        position: "relative",
        overflow: "hidden",
      }}>
        <div className="teasing-float" style={{
          position: "absolute", right: "8%", top: "10%",
          fontSize: "8rem", opacity: 0.06, lineHeight: 1,
          fontFamily: "'Alfa Slab One', serif",
          userSelect: "none",
        }}>?</div>
        <div className="teasing-float" style={{
          position: "absolute", left: "6%", bottom: "10%",
          fontSize: "5rem", opacity: 0.06, lineHeight: 1,
          fontFamily: "'Alfa Slab One', serif",
          userSelect: "none",
          animationDelay: "1s",
        }}>?</div>

        <div className="wb-fade-up">
          <span style={{
            display: "inline-block", fontWeight: 700, textTransform: "uppercase",
            letterSpacing: ".14em", fontSize: ".78rem",
            background: C.ink, color: C.gold, padding: "6px 14px", borderRadius: 30,
            marginBottom: 18,
          }}>
            {t("servicesBientot")}
          </span>

          <h1 style={{
            fontFamily: "'Alfa Slab One', serif",
            color: C.red,
            fontSize: "clamp(2.5rem, 8vw, 5rem)",
            lineHeight: .95,
            WebkitTextStroke: "2px #211B16",
            textShadow: `5px 5px 0 ${C.ink}`,
            marginBottom: 20,
          }}>
            {t("servicesHero")}
          </h1>

          <p style={{
            fontSize: "1.1rem", maxWidth: 500, margin: "0 auto",
            fontWeight: 500, color: C.inkSoft,
          }}>
            {t("servicesHeroSub")}
          </p>
        </div>
      </div>

      <Band />

      {/* CARDS SERVICES */}
      <div style={{ padding: "52px 20px", maxWidth: 1000, margin: "0 auto" }}>
        <div style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))",
          gap: 24,
        }}>
          {SERVICES.map((s) => (
            <div key={s.name} style={{
              background: s.bg,
              border: `3px solid ${C.ink}`,
              borderRadius: 16,
              boxShadow: `6px 6px 0 ${C.ink}`,
              overflow: "hidden",
            }}>
              {/* Header coloré */}
              <div style={{
                background: s.color,
                padding: "28px 24px 20px",
                display: "flex", flexDirection: "column", alignItems: "center",
                borderBottom: `3px solid ${C.ink}`,
                position: "relative",
              }}>
                <div style={{ fontSize: "3.5rem", marginBottom: 8 }}>{s.emoji}</div>
                <div style={{
                  fontFamily: "'Alfa Slab One', serif",
                  fontSize: "1.5rem",
                  color: C.cream,
                  WebkitTextStroke: `1px ${C.ink}`,
                  textShadow: `2px 2px 0 ${C.ink}`,
                }}>{s.name}</div>
                <div style={{
                  marginTop: 6,
                  background: C.ink,
                  color: C.gold,
                  fontSize: "0.7rem",
                  fontWeight: 700,
                  textTransform: "uppercase",
                  letterSpacing: ".1em",
                  padding: "4px 10px",
                  borderRadius: 20,
                }}>{s.tagline}</div>
              </div>

              {/* Body */}
              <div style={{ padding: "20px 24px 24px" }}>
                <p style={{ color: C.inkSoft, fontWeight: 500, lineHeight: 1.6, marginBottom: 16 }}>
                  {s.desc}
                </p>
                <div style={{
                  display: "inline-flex", alignItems: "center", gap: 8,
                  background: C.ink, color: C.cream,
                  fontWeight: 700, fontSize: "0.8rem",
                  textTransform: "uppercase", letterSpacing: ".06em",
                  padding: "8px 16px", borderRadius: 10,
                  border: `2px solid ${C.ink}`,
                  boxShadow: `3px 3px 0 ${s.color}`,
                }}>
                  {t("bientotDisponible")}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <Band />

      {/* MESSAGE FINAL */}
      <div style={{ padding: "52px 20px", textAlign: "center" }}>
        <div style={{
          maxWidth: 560, margin: "0 auto",
          background: C.cream,
          border: `4px solid ${C.ink}`,
          borderRadius: 16,
          boxShadow: `6px 6px 0 ${C.ink}`,
          padding: "36px 32px",
        }}>
          <div style={{ fontSize: "3rem", marginBottom: 12 }}>👀</div>
          <h2 style={{
            fontFamily: "'Alfa Slab One', serif",
            color: C.red,
            fontSize: "1.8rem",
            WebkitTextStroke: `1px ${C.ink}`,
            marginBottom: 10,
          }}>{t("resteConnecte")}</h2>
          <p style={{ color: C.inkSoft, fontWeight: 500 }}>
            {t("resteConnecteSub")}
          </p>
        </div>
      </div>

    </div>
  );
}